/**
 * This file is for storing graphql mutations. Split this file if it gets too large
 */

import { gql } from '@apollo/client'

export const CREATE_BUY_ORDER = gql`
  mutation createBuyOrder($amount: CurrencyInput!, $paymentMethodId: String!) {
    createBuyOrder(amount: $amount, paymentMethodId: $paymentMethodId) {
      internalKey
      orderId
    }
  }
`
export const CREATE_JBP_DEPOSIT_INVOICE = gql`
  mutation createJbpDepositInvoice($input: CreateJbpDepositInvoiceInput!) {
    createJbpDepositInvoice(input: $input) {
      outcome
      unavailablePaymentMethod
      invoice {
        invoiceId
        companyOrderNum
        mownecumOrderNum
        qrCodeImageUrl
        checkoutUrl
        accountName
        accountNum
        bankName
        bankAddress
        bankId
        requireAmount
        state
        requestedAmount
        paidAmount
        creditedAmount
        feeMode
        transactionFeeRate
        transactionFeeFlat
        transactionFeeAmount
        settledBy
        statusMessage
        callbackCount
        callbackVerified
        timeoutAt
        closedAt
        createdAt
        updatedAt
        settledAt
      }
    }
  }
`

export const CREATE_JBP_WITHDRAWAL_INVOICE = gql`
  mutation createJbpWithdrawalInvoice($input: CreateJbpWithdrawalInvoiceInput!) {
    createJbpWithdrawalInvoice(input: $input) {
      invoiceId
      userId
      companyOrderNum
      mownecumOrderNum
      bankId
      cardName
      cardNumMasked
      issueBankName
      issueBankAddress
      state
      requestedAmount
      paidAmount
      debitedAmount
      feeMode
      transactionFeeRate
      transactionFeeFlat
      transactionFeeAmount
      exactTransactionCharge
      statusMessage
      callbackCount
      callbackVerified
      timeoutAt
      closedAt
      createdAt
      updatedAt
      settledAt
    }
  }
`

export const USER_CREATE_SELL_ORDER = gql`
  mutation userCreateSellOrder(
    $totalDealAmount: CurrencyInput!
    $minDealAmount: CurrencyInput!
    $paymentMethodIds: [String!]!
  ) {
    userCreateSellOrder(
      totalDealAmount: $totalDealAmount
      minDealAmount: $minDealAmount
      paymentMethodIds: $paymentMethodIds
    ) {
      internalKey
      orderId
    }
  }
`
export const CREATE_WITHDRAWAL_MUTATION = gql`
  mutation createWithdrawal(
    $token: String!
    $network: Network!
    $address: String!
    $amount: CurrencyInput!
    $idempotencyId: Uuid!
    $password: String!
    $otp: String!
  ) {
    createWithdrawal(
      token: $token
      network: $network
      address: $address
      amount: $amount
      idempotencyId: $idempotencyId
      password: $password
      otp: $otp
    )
  }
`
export const USER_SUBMIT_KYC_LV1 = gql`
  mutation userSubmitKycLv1(
    $firstname: String!
    $lastname: String!
    $governmentId: String!
    $videoBucketFileName: String!
    $frontGovernmentIdFileName: String!
    $backGovernmentIdFileName: String!
    $countryRegion: String!
  ) {
    userSubmitKycLv1(
      firstname: $firstname
      lastname: $lastname
      governmentId: $governmentId
      videoBucketFileName: $videoBucketFileName
      frontGovernmentIdFileName: $frontGovernmentIdFileName
      backGovernmentIdFileName: $backGovernmentIdFileName
      countryRegion: $countryRegion
    )
  }
`
export const CANCEL_BUY_ORDER = gql`
  mutation cancelBuyOrder($buyOrderId: Uuid!) {
    cancelBuyOrder(buyOrderId: $buyOrderId)
  }
`
export const SELLER_REQUEST_CANCEL_SELL_ORDER = gql`
  mutation sellerRequestCancelSellOrder($sellOrderId: Uuid!) {
    sellerRequestCancelSellOrder(sellOrderId: $sellOrderId)
  }
`
export const BUYER_UPLOAD_PAYMENT_PROOF = gql`
  mutation buyerUploadPaymentProof($id: Uuid!, $paymentProofFileName: [String!]!) {
    buyerUploadPaymentProof(id: $id, paymentProofFileName: $paymentProofFileName)
  }
`
export const BUY_ORDER_REQUEST_APPEAL = gql`
  mutation buyOrderRequestAppeal(
    $buyOrderId: Uuid!
    $appealKind: Int!
    $appealProofFileName: [String!]!
    $appealReason: String
  ) {
    buyOrderRequestAppeal(
      buyOrderId: $buyOrderId
      appealKind: $appealKind
      appealProofFileName: $appealProofFileName
      appealReason: $appealReason
    )
  }
`
export const SELLER_COMPLAINT_BUY_ORDER_AMOUNT = gql`
  mutation sellerComplaintBuyOrderAmount(
    $buyOrderId: Uuid!
    $updateAmount: CurrencyInput!
    $withdrawalPassword: String!
    $changeAmountProofFileName: [String!]!
  ) {
    sellerComplaintBuyOrderAmount(
      buyOrderId: $buyOrderId
      updateAmount: $updateAmount
      withdrawalPassword: $withdrawalPassword
      changeAmountProofFileName: $changeAmountProofFileName
    )
  }
`
export const BUYER_CONFIRM_BUY_AMOUNT = gql`
  mutation buyerConfirmBuyAmount($buyOrderId: Uuid!) {
    buyerConfirmBuyAmount(buyOrderId: $buyOrderId)
  }
`
export const BUYER_DISAGREE_BUY_AMOUNT = gql`
  mutation buyerDisagreeBuyAmount($buyOrderId: Uuid!) {
    buyerDisagreeBuyAmount(buyOrderId: $buyOrderId)
  }
`
export const SELLER_CONFIRM_PAYMENT_PROOF = gql`
  mutation sellerConfirmPaymentProof($sellOrderId: Uuid!, $buyOrderId: Uuid!, $withdrawalPassword: String!) {
    sellerConfirmPaymentProof(
      sellOrderId: $sellOrderId
      buyOrderId: $buyOrderId
      withdrawalPassword: $withdrawalPassword
    )
  }
`
export const SET_USER_NICKNAME = gql`
  mutation setUserNickname($nickname: String!) {
    setUserNickname(nickname: $nickname) {
      id
      flags
      nickname
    }
  }
`
export const USER_MODIFY_PASSWORD = gql`
  mutation userModifyPassword($newPassword: String!, $oldPassword: String!) {
    userModifyPassword(newPassword: $newPassword, oldPassword: $oldPassword)
  }
`
export const UPLOAD_PAYMENT_METHOD = gql`
  mutation uploadPaymentMethod($paymentMethodInput: PaymentInfoInput!, $withdrawalPassword: String!) {
    uploadPaymentMethod(paymentMethodInput: $paymentMethodInput, withdrawalPassword: $withdrawalPassword)
  }
`
export const DELETE_PAYMENT_METHOD = gql`
  mutation deletePaymentMethod($paymentMethodId: String!, $withdrawalPassword: String!) {
    deletePaymentMethod(paymentMethodId: $paymentMethodId, withdrawalPassword: $withdrawalPassword)
  }
`
export const UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod(
    $paymentMethodInput: PaymentInfoInput!
    $currentVersion: String!
    $paymentMethodId: String!
    $withdrawalPassword: String!
  ) {
    updatePaymentMethod(
      paymentMethodInput: $paymentMethodInput
      currentVersion: $currentVersion
      paymentMethodId: $paymentMethodId
      withdrawalPassword: $withdrawalPassword
    )
  }
`
export const REQUEST_SET_USER_WITHDRAWAL_PASSWORD = gql`
  mutation requestSetUserWithdrawalPassword($locale: String!, $withdrawalPassword: String!) {
    requestSetUserWithdrawalPassword(locale: $locale, withdrawalPassword: $withdrawalPassword)
  }
`
export const SET_USER_WITHDRAWAL_PASSWORD = gql`
  mutation setUserWithdrawalPassword($token: String!, $password: String!) {
    setUserWithdrawalPassword(token: $token, password: $password)
  }
`
export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation markAllNotificationsAsRead($number: Int!) {
    markAllNotificationsAsRead(number: $number)
  }
`
export const READ_NOTIFICATION = gql`
  mutation readNotification($number: Int!) {
    readNotification(number: $number)
  }
`
export const USER_PAYMENT_GATE_WAY_TRANSFER = gql`
  mutation userPaymentGateWayTransfer($internalKey: String!, $withdrawalPassword: String!) {
    userPaymentGateWayTransfer(internalKey: $internalKey, withdrawalPassword: $withdrawalPassword)
  }
`
export const DISCONNECT_USER_CONNECTED_APP = gql`
  mutation disconnectUserConnectedApp($connectedAppId: String!) {
    disconnectUserConnectedApp(connectedAppId: $connectedAppId)
  }
`
export const APPROVE_CONNECT_APP_SESSION = gql`
  mutation approveConnectAppSession($connectId: String!) {
    approveConnectAppSession(connectId: $connectId)
  }
`
export const RESET_USER_KYC_LV1 = gql`
  mutation resetUserKycLv1 {
    resetUserKycLv1
  }
`
export const REQUEST_CANCEL_PAIR_BUY_SELL_ORDER = gql`
  mutation requestCancelPairBuySellOrder($buyOrderId: Uuid!, $sellOrderId: Uuid!, $cashflowProofFileName: String!) {
    requestCancelPairBuySellOrder(
      buyOrderId: $buyOrderId
      sellOrderId: $sellOrderId
      cashflowProofFileName: $cashflowProofFileName
    )
  }
`

export const REDEEM_PROMO_TICKET = gql`
  mutation redeemPromoTicket($ticketId: String!) {
    redeemPromoTicket(ticketId: $ticketId) {
      ticketId
      promoId
      promoCode
      promoVersion
      rewardAmount
      rewardLabel
      rewardOutcome
      roll
      alreadyRedeemed
    }
  }
`
